/* Display adapter only. Do not change selling plans, quantities or discounts. */
if (!customElements.get('ae-purchase-offer-prices')) {
  class PurchaseOfferPrices extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      try {
        this.prices = JSON.parse(this.querySelector('script').textContent);
      } catch (error) {
        return;
      }
      this.root = this.closest('.shopify-section');
      if (!this.root) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.refresh();
        });
      };
      this.observer = new MutationObserver(this.schedule);
      this.root.addEventListener('change', this.schedule);
      this.root.addEventListener('click', this.schedule);
      this.root.addEventListener('on:variant:change', this.schedule);
      this.refresh();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.root?.removeEventListener('change', this.schedule);
      this.root?.removeEventListener('click', this.schedule);
      this.root?.removeEventListener('on:variant:change', this.schedule);
      this.observer = null;
    }

    refresh() {
      // Disconnect while rendering so our own display writes cannot loop.
      this.observer.disconnect();
      try {
        const form = this.root.querySelector('.js-product-form-main');
        const variantId = form?.querySelector('[name="id"]')?.value;
        const activeOption = this.root.querySelector('.sls-option-container.sls-active');
        const subscription = !!activeOption?.querySelector('[data-type="subscription"]');
        const planId = activeOption?.querySelector('[name="subs_interval"]')?.value
          || form?.querySelector('[name="selling_plan"]')?.value;
        const plan = this.prices.variants[variantId]?.[planId];

        this.root.querySelectorAll('.bundler-volume-target-element.bndlr-quantity-break').forEach(widget => {
          if (widget.dataset.productId !== String(this.prices.productId)) return;
          widget.classList.add('ae-offer-prices');
          widget.classList.toggle('ae-subscription-selected', subscription);
          widget.querySelectorAll('.bndlr-radio-container').forEach(row => {
            const quantity = row.querySelector('input[name="bundle_quantity"]')?.value;
            const group = row.querySelector('.bndlr-radio-text-group');
            const wrapper = row.querySelector('.bndlr-text-price-wrapper');
            if (!quantity || !group || !wrapper) return;
            let label = group.querySelector('.ae-subscription-label');
            if (!label) {
              label = document.createElement('span');
              label.className = 'ae-subscription-label';
              group.appendChild(label);
            }
            let price = wrapper.querySelector('.ae-subscription-price');
            if (!price) {
              price = document.createElement('span');
              price.className = 'ae-subscription-price';
              wrapper.appendChild(price);
            }
            label.textContent = `Buy ${quantity}`;
            // If an app briefly changes selection before data is ready, never
            // show a stale one-time discount as the subscription total.
            price.textContent = plan?.totals[quantity] || 'See cart total';
          });
          if (!widget.querySelector('.ae-subscription-note')) {
            const note = document.createElement('p');
            note.className = 'ae-subscription-note';
            note.textContent = 'Subscription pricing. Quantity discounts do not combine.';
            widget.appendChild(note);
          }
        });
      } finally {
        this.observer.observe(this.root, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'value', 'aria-checked', 'data-variant-id', 'data-bundler-break-active']
        });
      }
    }
  }
  customElements.define('ae-purchase-offer-prices', PurchaseOfferPrices);
}
